/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_No_ExperimentsInputs */

const en_pricing_no_experiments = /** @type {(inputs: Pricing_No_ExperimentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pricing experiments on this page.`)
};

const es_pricing_no_experiments = /** @type {(inputs: Pricing_No_ExperimentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay experimentos de precios en esta página.`)
};

/**
* | output |
* | --- |
* | "No pricing experiments on this page." |
*
* @param {Pricing_No_ExperimentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_no_experiments = /** @type {((inputs?: Pricing_No_ExperimentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_No_ExperimentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_no_experiments(inputs)
	return en_pricing_no_experiments(inputs)
});